<template>
  <div v-if="homepage">
    <h3>Brand Message</h3>
    <div class="h4 py-5">顯示於首頁</div>
    <div class="form-item d-flex pt-5">
      <label class="w-174px mr-6px"><h4>Title</h4></label>
      <div class="h4 mt-n2 flex-grow-1">
        <v-textarea
          v-model="homepage.title"
          outlined
          dense
        ></v-textarea>
      </div>
    </div>
    <div class="form-item d-flex pt-5">
      <label class="w-174px mr-6px"><h4>Description</h4></label>
      <div class="h4 mt-n2 flex-grow-1">
        <v-textarea
          v-model="homepage.description"
          outlined
          dense
        ></v-textarea>
      </div>
    </div>
    <div class="form-item d-flex pt-5" style="border-bottom: none">
      <label class="w-174px mr-6px">
        <h4>Call To Action</h4>
      </label>
      <div class="h4 mt-n2 mt-n2 flex-grow-1">
        <v-text-field
          v-model="homepage.call_to_action"
          outlined
          dense
        ></v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    homepage: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style></style>
